import React, {Component, createRef} from "react";
import AppContext from "../../appContext";
import HeaderLogo from "./header-logo";
import UserMenu from "./user-menu/user-menu";
import OticaMenu from "./otica-menu/otica-menu";
import ReactLoading from "react-loading";
import {Link} from "react-router-dom";
import {withStyles} from "@material-ui/core/styles";
import {AppBar, Box, Toolbar} from "@material-ui/core";

const styles = (_) => ({
  appBar: {
    backgroundColor: "#f8f8f8",
    boxShadow: "none",
    height: 70,
  },
  toolbar: {
    minHeight: 70,
    padding: "0 40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
  },
  menuItems: {
    display: "flex",
    alignItems: "center",
    listStyle: "none",
    margin: 0,
    padding: 0,
    flexWrap: "nowrap",
    position: "relative",
  },
  slidingHover: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    backgroundColor: "#0394db",
    borderRadius: 4,
    pointerEvents: "none",
    zIndex: 0,
  },
  menuItem: {
    display: "flex",
    cursor: "pointer",
  },
  menuLink: {
    color: "#00518A",
    fontSize: "0.9375rem",
    lineHeight: "38px",
    padding: "9px 10px",
    fontWeight: 600,
    textDecoration: "none",
    whiteSpace: "nowrap",
    borderRadius: 4,
    cursor: "pointer",
    display: "block",
    position: "relative",
    zIndex: 1,
    transition: "color 0.1s ease",
    "&:hover": {
      color: "#ffffff",
    },
  },
  menuLinkActive: {
    color: "#ffffff",
  },
  menuLinkFallback: {
    "&:hover": {
      backgroundColor: "#0394db",
    },
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    position: "relative",
    cursor: "pointer",
  },
  rightSlidingHover: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    borderRadius: 4,
    pointerEvents: "none",
    zIndex: 0,
  },
  hoverBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 8px",
    borderRadius: 4,
    cursor: "pointer !important",
    minHeight: 44,
    position: "relative",
    zIndex: 1,
    "& *": {
      cursor: "pointer !important",
    },
  },
  hoverBoxAvatar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "9px 13px",
    borderRadius: 4,
    cursor: "pointer !important",
    minHeight: 44,
    position: "relative",
    zIndex: 1,
    "& *": {
      cursor: "pointer !important",
    },
  },
  verticalDivider: {
    height: 32,
    width: 1,
    margin: "0 12px",
    backgroundColor: "#ccc",
    zIndex: 1,
    pointerEvents: "none",
  },
});

class HeaderDesktop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lock: false,
      redirect: false,
      disabled: false,
      modulos: [],
      especialista: "",
      load: true,
      oticaLoad: true,
      hoverLeft: 0,
      hoverWidth: 0,
      hoverOpacity: 0,
      hoverTransition: true,
      hoveredIndex: null,
      rightHoverLeft: 0,
      rightHoverWidth: 0,
      rightHoverOpacity: 0,
      rightHoverTransition: true,
      rightHoveredIndex: null,
    };

    this.menuRef = createRef();
    this.rightSectionRef = createRef();

    HeaderDesktop.contextType = AppContext;
    this.compare = this.compare.bind(this);
    this.acessaGestaoPapeis = this.acessaGestaoPapeis.bind(this);
    this.hasMinhaOtica = this.hasMinhaOtica.bind(this);
    this.handleMenuItemHover = this.handleMenuItemHover.bind(this);
    this.handleMenuLeave = this.handleMenuLeave.bind(this);
    this.handleRightItemHover = this.handleRightItemHover.bind(this);
    this.handleRightLeave = this.handleRightLeave.bind(this);
  }

  isEspecialistaPremiere(modulos) {
    if (this.context.especialistaPremiere === "VARILUX ESPECIALISTA PREMIER" || this.context.especialistaPremiere === "VARILUX ESPECIALISTA PLATINE") {
      return modulos;
    } else if (this.context.userSession.conta === "30260871000105" && this.context.userSession.papel === "Dev") {
      return modulos;
    } else {
      return modulos.filter((item, _) => {
        return item !== "Relacionamento Digital";
      });
    }
  }

  componentDidMount() {
    if (sessionStorage.getItem("token") != null) {
      const modulosAux = this.isEspecialistaPremiere(this.context.userSession.modulos);
      const especialista = !!(this.context.especialistaPremiere && this.context.especialistaPremiere.includes("VARILUX"));

      const mods = [];

      const requestOptions1 = {
        method: "POST",
        body: JSON.stringify({
          modulos: modulosAux,
          especialista: especialista,
        }),
      };

      fetch(process.env.REACT_APP_LABS_API + "get_modules_header.php", requestOptions1)
        .then(response => {
          return response.json();
        })
        .then(json => {
          if (json.items) {
            for (let i = 0; i < json.items.length; i++) {
            const displayName = json.items[i].RecordName === "Gerar Cupons" ? "Pedidos Promocionais" : json.items[i].RecordName;
              const pushObj = {
                nome: displayName,
                pos: json.items[i].Posicao_c,
                url: json.items[i].URL_c,
                tab: json.items[i].NovaAba_c,
              };

              if (!json.items[i].OticasPilotos_c) {
                mods.push(pushObj);
              } else {
                const contas = json.items[i].OticasPilotos_c.split(";");
                if (contas.some(elem => elem.includes(this.context.userSession.conta))) {
                  mods.push(pushObj);
                }
              }
            }

            mods.sort(this.compare);
            this.setState({ modulos: mods, load: false });
          }
        });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lista_multi_contas !== null) {
      this.setState({ oticaLoad: false });
    }
  }

  compare(a, b) {
    if (a.pos < b.pos) {
      return -1;
    }
    if (a.pos > b.pos) {
      return 1;
    }
    return 0;
  }

  acessaGestaoPapeis() {
    return this.context.userSession.modulos.includes("Gestão Papéis");
  }

  hasMinhaOtica() {
    return this.context.userSession.modulos.includes("Minha Ótica");
  }

  handleMenuItemHover(index, element) {
    if (!this.menuRef.current || !element) return;

    const menuRect = this.menuRef.current.getBoundingClientRect();
    const itemRect = element.getBoundingClientRect();
    const newLeft = itemRect.left - menuRect.left;
    const newWidth = itemRect.width;

    const { hoverOpacity, hoveredIndex } = this.state;
    const isAdjacent = hoveredIndex !== null && Math.abs(index - hoveredIndex) <= 1;
    const shouldSlide = hoverOpacity > 0 && isAdjacent;

    if (shouldSlide) {
      this.setState({
        hoverLeft: newLeft,
        hoverWidth: newWidth,
        hoveredIndex: index,
      });
    } else {
      this.setState({
        hoverLeft: newLeft,
        hoverWidth: newWidth,
        hoverTransition: false,
        hoveredIndex: index,
      }, () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.setState({
              hoverOpacity: 1,
              hoverTransition: true,
            });
          });
        });
      });
    }
  }

  handleMenuLeave() {
    this.setState({
      hoverOpacity: 0,
      hoveredIndex: null,
    });
  }

  handleRightItemHover(index, element) {
    if (!this.rightSectionRef.current || !element) return;

    const sectionRect = this.rightSectionRef.current.getBoundingClientRect();
    const itemRect = element.getBoundingClientRect();
    const newLeft = itemRect.left - sectionRect.left;
    const newWidth = itemRect.width;

    const { rightHoverOpacity, rightHoveredIndex } = this.state;
    const isAdjacent = rightHoveredIndex !== null && Math.abs(index - rightHoveredIndex) <= 1;
    const shouldSlide = rightHoverOpacity > 0 && isAdjacent;

    if (shouldSlide) {
      this.setState({
        rightHoverLeft: newLeft,
        rightHoverWidth: newWidth,
        rightHoveredIndex: index,
      });
    } else {
      this.setState({
        rightHoverLeft: newLeft,
        rightHoverWidth: newWidth,
        rightHoverTransition: false,
        rightHoveredIndex: index,
      }, () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.setState({
              rightHoverOpacity: 1,
              rightHoverTransition: true,
            });
          });
        });
      });
    }
  }

  handleRightLeave() {
    this.setState({
      rightHoverOpacity: 0,
      rightHoveredIndex: null,
    });
  }

  render() {
    const { classes } = this.props;

    if (this.state.redirect) {
      window.location.href = "/";
    }

    return (
      <AppBar position="static" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Box className={classes.logoContainer}>
            <HeaderLogo />
          </Box>

          <Box component="nav" flex={1} ml={4} style={{ minWidth: 0 }}>
            <ul
              className={classes.menuItems}
              ref={this.menuRef}
              onMouseLeave={this.handleMenuLeave}
            >
              <div
                className={classes.slidingHover}
                style={{
                  left: this.state.hoverLeft,
                  width: this.state.hoverWidth,
                  opacity: this.state.hoverOpacity,
                  transition: this.state.hoverTransition
                    ? "left 0.15s ease-out, width 0.15s ease-out, opacity 0.1s ease"
                    : "none",
                }}
              />
              {this.state.modulos.map((item, index) => (
                <li
                  key={index}
                  className={classes.menuItem}
                  onMouseEnter={(e) => this.handleMenuItemHover(index, e.currentTarget)}
                >
                  <Link
                    className={`${classes.menuLink} ${this.state.hoveredIndex === index ? classes.menuLinkActive : ''} ${this.state.hoverOpacity === 0 ? classes.menuLinkFallback : ''}`}
                    target={item.tab === true ? "_blank" : ""}
                    to={item.url}
                  >
                    {item.nome}
                  </Link>
                </li>
              ))}
            </ul>
          </Box>

          <Box
            className={classes.rightSection}
            ref={this.rightSectionRef}
            onMouseLeave={this.handleRightLeave}
          >
            <div
              className={classes.rightSlidingHover}
              style={{
                left: this.state.rightHoverLeft,
                width: this.state.rightHoverWidth,
                opacity: this.state.rightHoverOpacity,
                transition: this.state.rightHoverTransition
                  ? "left 0.15s ease-out, width 0.15s ease-out, opacity 0.1s ease"
                  : "none",
              }}
            />
            <Box
              className={classes.hoverBox}
              onMouseEnter={(e) => this.handleRightItemHover(0, e.currentTarget)}
              onClick={(_) => {
                this.handleRightLeave();
                const offcanvas = document.querySelector(".offcanvas.show");
                if (offcanvas) return;
                const btn = document.getElementById("headerBtn");
                if (btn) btn.click();
              }}
            >
              {this.state.oticaLoad ? (
                <ReactLoading type="bubbles" color="#00518b" height={65} width={65} />
              ) : (
                <OticaMenu lista_multi_contas={this.props.lista_multi_contas} />
              )}
            </Box>
            <Box className={classes.verticalDivider} />
            <Box
              className={classes.hoverBoxAvatar}
              onMouseEnter={(e) => this.handleRightItemHover(1, e.currentTarget)}
              onClick={(e) => {
                this.handleRightLeave();
                const menu = document.querySelector('.MuiMenu-paper');
                if (menu) return;
                const btn = e.currentTarget.querySelector("button");
                if (btn) btn.click();
              }}
            >
              <UserMenu hasMinhaOtica={this.hasMinhaOtica} acessaGestaoPapeis={this.acessaGestaoPapeis} />
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
    );
  }
}

export default withStyles(styles)(HeaderDesktop);